const isoToUnixTimestamp = (isoString) => {
  let date = new Date(isoString);
  let unixTimestamp = Math.floor(date.getTime() / 1000);
  return unixTimestamp.toString();
};

export default isoToUnixTimestamp;
